<template lang="pug">
  main
    NavBarCORP
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.section-title
          .column.is-half.is-offset-one-quarter.has-text-centered.has-text-dark
            h1.title Archivos&nbsp
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        nav.breadcrumb.is-centered(aria-label="breadcrumbs")
          ul
            li
              a.is-secondarys(href="/Apartado/SASISOPA") Terminales
            li
              router-link.a.is-secondarys(:to="`/SASISOPA/documentos/${this.$route.params.terminal_id}`")  Documentos
            li
              router-link.a.is-secondarys(:to="`/SASISOPA/ambitos/${this.$route.params.terminal_id}/${this.$route.params.document_id}`") Ambitos
            li
              a.is-secondarys Archivos
        .file-list
          .file-item(v-for="(document, index) in documents" :key="index")
            .file-details
              p.has-text-weight-medium.is-size-12 {{ document.file_name }}
            router-link.a.button.is-black.is-rounded.is-size-7.mr-1(:to="`/SASISOPA/archivo/${document.id}`" title="Visualizar archivo")
              i.fas.fa-eye.fa-stack-1x.fa-inverse
            a.button.is-danger.is-rounded.is-size-7( @click="deleteItem(document.id)" v-if="permisos.permisos_sasisopa_id == 1")
              i.fas.fa-trash.fa-stack-1x.fa-inverse

        .file-details.is-flex.is-justify-content-flex-end
          //- a.button.is-black.is-rounded.is-size-6( @click="addFile" :to="`/SASISOPA/archivo/${idRoute}/agregar`" title="Agregar un archivo")
          a.button.is-black.is-rounded.is-size-6( @click="addFile" v-if="this.permisos.permisos_sasisopa_id == 1")
            i.fas.fa-plus.fa-stack-1x.fa-inverse

        input#fileInput(type="file" style="display: none" @change="handleFileChange" ref="fileInput")

        .modal.is-active(v-if="isModalActive")
              .modal-background.custom-background
              .modal-card
                header.modal-card-head
                  p.modal-card-title ¿Estás seguro de que deseas eliminar esta ARCHIVO?
                  button.modal-close.is-large(@click="closeModal")
                  button.button(@click="closeModal")
                    i.fas.fa-times
                section.modal-card-body.has-text-centered
                  i.is-alert.is-large.fa.fa-exclamation.mb-2
                  br
                  br
                  strong Esta acción es irreversible y el ARCHIVO ELIMIADO NO SE PODRA RECUPERAR
                footer.modal-card-foot.has-text-right
                  .buttons
                    button.button.is-dark(@click="confirmDelete") Eliminar de todos modos
                    button.button.is-black(@click="closeModal") Cancelar


</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarCORP from '@/components/layout/NavBarCorpo.vue'
import { mapState } from 'vuex'
import sasisopaAPI from "@/services/axios_sasisopa.js";

export default {
  name: 'FilesSASISOPA',
  components: { Loader, NavBarCORP },
  data () {
    const id = this.$route.params.id;
    return {
      isLoading: false,
      documents: [],
      idRoute: id,
      DocumentToDelete: null,
      isModalActive: false,
    }
  },
  methods: {
  async fetchData() {
      try {
        this.isLoading = true;
        const response = await sasisopaAPI.getFiles(this.$route.params.id);
        this.documents = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.isLoading = false;
      }
    },

  deleteItem(id) {
      this.DocumentToDelete = id;
      this.isModalActive = true;
    },
    async confirmDelete() {
      if (this.DocumentToDelete) {
        try {
          this.isLoading = true;
          await sasisopaAPI.DeleteFiles(this.DocumentToDelete);
          this.Documents = this.Documents.filter(Document => Document.id !== this.DocumentToDelete);
        } catch (error) {
          this.fetchData();
        } finally {
          this.isLoading = false;
          this.isModalActive = false;
          this.DocumentToDelete = null;
        }
      }
    },
    closeModal(){
      this.isModalActive = false;
    },

  addFile() {
    this.$refs.fileInput.click();
  },

  async handleFileChange(event) {
    const file = event.target.files[0];
    if (file) {
      try {
          const data = {
            name: file.name,
            id: this.$route.params.id,
            file: file,
          };
          const response = await sasisopaAPI.postFiles(data);
          this.fetchData();
          return response;
        } catch (error) {
          this.datosFaltantes.push(error|| 'Error al guardar la terminal.');
          throw error;
        }

    }
  },
  backPage() {
    this.$router.back();
  },
  obtenerUser() {
  },
},

  created () {
    this.$store.commit('irEstaciones','CORP')
    this.obtenerUser()
    this.fetchData();
  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'permisos'])
  },

}
</script>

<style lang="css" scoped>
.file-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
  transition: background-color 0.3s, box-shadow 0.3s;
  height: 2.4rem;
}

.file-item:hover {
  background-color: #e0e0e0;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.file-icon {
  margin-right: 1rem;
}

.file-details {
  flex-grow: 1;
}

.file-details .button {
  margin-top: 0.5rem;
}
    .custom-background {
  background-color: #0c0c0cc0;
}
.is-alert {
  color: rgb(245, 68, 68);
}

.modal-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fa-exclamation {
  font-size: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/sasisopa/FilesSASISOPA.vue